import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CONSULTANT_SEARCH_LINK } from '@/define/consts/url';
import { PROFFIT_TOP_SERVICE_FLOW_STEP_ONE, PROFFIT_TOP_SERVICE_FLOW_STEP_TWO, PROFFIT_TOP_SERVICE_FLOW_STEP_THREE, PROFFIT_TOP_SERVICE_FLOW_ONE, PROFFIT_TOP_SERVICE_FLOW_TWO, PROFFIT_TOP_SERVICE_FLOW_THREE, } from '@/utils/constants/assets/s3';
import { documentOnePath } from '@/utils/router/links';
export const topServiceFlowItems = [
    {
        button: {
            linkTo: documentOnePath(3, 40),
            target: '_blank',
            text: 'オーダーシート事例集を見る',
        },
        head: (_jsxs(_Fragment, { children: ["\u30B3\u30F3\u30B5\u30EB\u9078\u3073\u306E\u30D7\u30ED\u304C\u3001", _jsx("br", {}), "\u4F9D\u983C\u8981\u4EF6\u3092\u5FB9\u5E95\u6574\u7406"] })),
        list: [
            '大手コンサルファーム出身者が専任で支援',
            '営業日1日以内にオーダーシートを納品',
            'コンサルを活用すべきかどうかから相談可能',
        ],
        mainImage: {
            alt: '',
            src: PROFFIT_TOP_SERVICE_FLOW_STEP_ONE.base,
            webpSrc: PROFFIT_TOP_SERVICE_FLOW_STEP_ONE.webp,
        },
        slider: [
            {
                alt: '提案を具体化するための『5W+1G』 を記載',
                imageHeight: 158,
                imageWidth: 280,
                src: PROFFIT_TOP_SERVICE_FLOW_ONE.one.base,
                webpSrc: PROFFIT_TOP_SERVICE_FLOW_ONE.one.webp,
            },
            {
                alt: '経験・実力によって差がつく質問をぶつける',
                imageHeight: 158,
                imageWidth: 280,
                src: PROFFIT_TOP_SERVICE_FLOW_ONE.two.base,
                webpSrc: PROFFIT_TOP_SERVICE_FLOW_ONE.two.webp,
            },
            {
                alt: '予算や期間の条件もオンラインですり合わせ',
                imageHeight: 158,
                imageWidth: 280,
                src: PROFFIT_TOP_SERVICE_FLOW_ONE.three.base,
                webpSrc: PROFFIT_TOP_SERVICE_FLOW_ONE.three.webp,
            },
        ],
        supplement: 'コンサル選定アドバイザーが1時間のヒアリングを通じて相談の背景や課題、依頼事項を整理し、オーダーシートを作成します。',
    },
    {
        button: {
            linkTo: CONSULTANT_SEARCH_LINK,
            target: '_self',
            text: '登録コンサルタントを見る',
        },
        head: (_jsxs(_Fragment, { children: ["\u5B9F\u7E3E\u8C4A\u5BCC\u306A\u30B3\u30F3\u30B5\u30EB\u304B\u3089\u3001", _jsx("br", {}), "\u63D0\u6848\u3092\u4E00\u62EC\u52DF\u96C6"] })),
        list: [
            '提案募集は全てオンラインで完結',
            '平均1週間で約5件程度の提案を厳選',
            '企業名を「非開示」で募集することも可能',
        ],
        mainImage: {
            alt: '',
            src: PROFFIT_TOP_SERVICE_FLOW_STEP_TWO.base,
            webpSrc: PROFFIT_TOP_SERVICE_FLOW_STEP_TWO.webp,
        },
        slider: [
            {
                alt: '実力派コンサルの多彩な提案を徹底比較',
                imageHeight: 158,
                imageWidth: 280,
                src: PROFFIT_TOP_SERVICE_FLOW_TWO.one.base,
                webpSrc: PROFFIT_TOP_SERVICE_FLOW_TWO.one.webp,
            },
            {
                alt: '500社・3000名の実績データに基づき有望候補者に告知',
                imageHeight: 158,
                imageWidth: 280,
                src: PROFFIT_TOP_SERVICE_FLOW_TWO.two.base,
                webpSrc: PROFFIT_TOP_SERVICE_FLOW_TWO.two.webp,
            },
            {
                alt: '募集中のプロジェクト',
                imageHeight: 158,
                imageWidth: 280,
                src: PROFFIT_TOP_SERVICE_FLOW_TWO.three.base,
                webpSrc: PROFFIT_TOP_SERVICE_FLOW_TWO.three.webp,
            },
        ],
        supplement: '500社以上のコンサルのうち、関連実績を持つ有望なチームから具体的な検討方法やポイントが記載された提案書が提出されます。',
    },
    {
        button: {
            linkTo: documentOnePath(1, 12),
            target: '_blank',
            text: 'コンサル活用ガイドを見る',
        },
        head: (_jsxs(_Fragment, { children: ["\u5FB9\u5E95\u6BD4\u8F03\u306B\u5411\u3051\u305F", _jsx("br", {}), "\u30DD\u30A4\u30F3\u30C8\u89E3\u8AAC\u30FB\u30A2\u30C9\u30D0\u30A4\u30B9"] })),
        list: [
            'コンサルや提案内容の特長を解説',
            '面談での質問や評価の観点をアドバイス',
            '発注すべきか迷った際にも相談可能',
        ],
        mainImage: {
            alt: '',
            src: PROFFIT_TOP_SERVICE_FLOW_STEP_THREE.base,
            webpSrc: PROFFIT_TOP_SERVICE_FLOW_STEP_THREE.webp,
        },
        slider: [
            {
                alt: '内容と費用の両面で評価有望コンサルに絞って面談',
                imageHeight: 158,
                imageWidth: 280,
                src: PROFFIT_TOP_SERVICE_FLOW_THREE.one.base,
                webpSrc: PROFFIT_TOP_SERVICE_FLOW_THREE.one.webp,
            },
            {
                alt: '発注理由・選定プロセスのとりまとめもサポート',
                imageHeight: 158,
                imageWidth: 280,
                src: PROFFIT_TOP_SERVICE_FLOW_THREE.two.base,
                webpSrc: PROFFIT_TOP_SERVICE_FLOW_THREE.two.webp,
            },
            {
                alt: '面談先を決める',
                imageHeight: 158,
                imageWidth: 280,
                src: PROFFIT_TOP_SERVICE_FLOW_THREE.three.base,
                webpSrc: PROFFIT_TOP_SERVICE_FLOW_THREE.three.webp,
            },
        ],
        supplement: '面談での質問事項や評価の観点など、PROFFITのアドバイスを参考に有望なコンサル会社と面談を進め、発注先を決定します。',
    },
];
